'use strict';

module.exports = {
  init() {
    if (!window.GIG) {
      return;
    }
    if (window.GIG.Forms) {
      window.GIG.Forms.reloadBindings();
    }
    if (window.GIG.Modal) {
      window.GIG.Modal.reloadBindings();
    }
    if (window.GIG.Tooltip) {
      window.GIG.Tooltip.reloadBindings('section.main');
    }
    if (window.GIG.Tabs) {
      window.GIG.Tabs.reloadBindings();
    }
  },
};
